import { createRoute } from 'framework/routing';

const PAYROLL_REPORTS_PATH = '/payroll-reports';

export const getGeneratedPayrollsListUrl = () => PAYROLL_REPORTS_PATH;

export const getGeneratedPayrollsRouterPath = () => PAYROLL_REPORTS_PATH;

export const useGeneratedPayrollsRoute = () => createRoute({ listRoute: PAYROLL_REPORTS_PATH });
